<template>
  <div v-loading="loading" element-loading-text="转写中，请稍后…… " element-loading-spinner="el-icon-loading">
    <div class="voiced_warp" v-if="showType == 1">
      <i class="el-icon-error" @click="close"></i>
      <img :src="imgArr.a3" class="voiced_warp_bg">
      <div class="voiced_warp_title">语音病历助手</div>
      <div class="voiced_warp_desc">
        <div>边说边记录，无需手动输入</div>
        <div>自动区分医生与患者对话</div>
        <div>一键生成结构化病历</div>
      </div>
      <div class="voiced_warp_btn" @click.stop="startRecording">
        <i class="el-icon-microphone"></i>
        <div>开始录音</div>
      </div>
    </div>
    <!-- <div class="voiced_ing_warp" v-show="showType == 2">
      <div class="voiced_ing_warp_title">录音中...</div>
      <div class="voiced_ing_warp_time">{{ formatSeconds }}</div>
      <div ref="lottieContainer" class="voiced_ing_warp_img"></div>
      <div class="voiced_ing_warp_text" ref="voiceWarp">
        <div class="scroll_text" :style="{ animationDuration: animationDuration + 's' }">{{ showText }}</div>
      </div>
      <div class="voiced_ing_warp_btn" @click.stop="stopRecording">
        <i class="el-icon-switch-button"></i>
        <div>结束录音</div>
      </div>
    </div> -->
    <div class="voiced_ing_warp2" v-show="showType == 2">
      <div class="voiced_ing_warp2_left">
        <div ref="lottieContainer" class="voiced_ing_warp_img"></div>
        <div class="voiced_ing_warp_center">
          <div class="voiced_ing_warp_title">录音中</div>
          <div class="voiced_ing_warp_time">{{ formatSeconds }}</div>
        </div>
      </div>
      <div class="voiced_ing_warp_btn" @click.stop="stopRecording">
        <i class="el-icon-switch-button"></i>
        <div>结束</div>
      </div>
    </div>
  </div>
</template>

<script>
import lottie from 'lottie-web';
import { imgArr } from '@/assets/images/img';
import { stop } from '@/api/voice';
import { isNull, isEmptyArray, deepClone,debounce } from '@/utils/validateBase';
import req from '@/utils/request';
import animation from '@/assets/images/animation.json'
import Recording from '@/assets/images/Recording.json'
export default {
  data() {
    return {
      imgArr: imgArr,
      showType: 1,
      session_id: '',
      eventSource: null,
      voiceText: '',
      voiceTime: 0,
      showText: '',
      textWidth: 0,
      containerWidth: 0,
      speed: 50, // 像素/秒
      loading: false,

    };
  },
  computed: {
    formatSeconds() {
      let seconds = this.voiceTime;
      const mins = Math.floor(seconds / 60);
      const secs = seconds % 60;
      return `${mins}:${secs.toString().padStart(2, '0')}`;
    },
    animationDuration() {
      if (!this.textWidth || !this.containerWidth) return 10;
      return (this.textWidth + this.containerWidth) / this.speed;
    }
  },
  mounted() {
    // this.calculateWidths();
    // window.addEventListener('resize', this.calculateWidths);
    let anim = lottie.loadAnimation({
      container: this.$refs.lottieContainer, // DOM 容器
      renderer: 'svg', // 渲染方式（svg / canvas / html）
      loop: true,
      autoplay: true,
      animationData: Recording, // JSON 文件路径（或直接传 animationData）
    });
    anim.setSpeed(1.5);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.calculateWidths);
    this.stop()
  },
  methods: {
    calculateWidths() {
      this.$nextTick(() => {
        const textElement = this.$el.querySelector('.scroll_text');
        this.textWidth = textElement.scrollWidth;
        this.containerWidth = this.$refs.voiceWarp.offsetWidth;
      });
    },
    async startRecording() {
      stop().then(()=>{
        this.voiceTime = 0
        this.voiceText = ''
        
        if (!isNull(this.eventSource)) {
          this.closeSSE()
        }
        this.connectSSE()
      })
    },
    //关闭
    stop:debounce(async function () { 
      let { code, data } = await stop();
      if (code == 200) {
        console.log(1111);
        
        this.closeSSE()
        this.showType = 1
      }
    },500,true),
    async stopRecording() {
      this.stop()
      clearTimeout(this.timeId)
      this.$emit('stopRecording', { time: this.voiceTime, text: this.voiceText })
    },
    closeSSE() {
      if (this.eventSource) {
        this.eventSource.close(); // 关闭连接
        this.eventSource = null;
      }
    },
    connectSSE() {
      // 替换为你的 SSE 服务端 URL
      this.eventSource = new EventSource(`${this.$voiceUrl}/start`);
      // 监听消息事件（默认事件名是 'message'）
      this.eventSource.addEventListener('message', (event) => {
        let data = JSON.parse(event.data);
        if(data.type == 'START'){
           this.showType = 2
          this.startTime()
        }else if(data.type == 'DATA' && data.slice_type == 2) {
          this.voiceText += data.voice_text_str
        } else if (data.type == 'STOP') {
          this.closeSSE()
        }
      });

      // 监听自定义事件（如 'update'）
      this.eventSource.addEventListener('update', (event) => {
        console.log('自定义事件数据:', event.data);
      });

      // 错误处理
      this.eventSource.addEventListener('error', (error) => {
        console.error('SSE 连接错误:', error);
        this.closeSSE(); // 尝试重新连接
      });
    },
    startTime() {
      let voiceTime = deepClone(this.voiceTime)
      this.timeId = setTimeout(() => {
        voiceTime++
        this.$set(this, 'voiceTime', voiceTime)
        this.$forceUpdate()
        this.startTime()
      }, 1 * 1000);
    },
    close() {
      this.$emit('close')
    },

  },

}
</script>
<style lang="less" scoped>
@keyframes scroll {
  0% {
    transform: translateX(0);
  }

  100% {
    transform: translateX(-100%);
  }
}

.voiced_warp {
  width: 340px;
  height: 368px;
  background: linear-gradient(180deg, #DFEFFE 0%, #D6EAFD 20%, #FFFFFF 100%);
  box-shadow: 0px 0px 20px 0px rgba(26, 144, 255, 0.07), inset 0px -4px 20px 0px rgba(255, 255, 255, 0.8);
  // border: 2px solid;
  // border-image: linear-gradient(to bottom, #D1E9FF, #FFFFFF) 8;
  border-radius: 8px 8px 8px 8px;
  padding: 48px 28px 0 28px;
  box-sizing: border-box;
  position: relative;

  .el-icon-error {
    position: absolute;
    top: 28px;
    right: 28px;
    color: #fff;

    &::before {
      font-size: 26px;
    }
  }

  &::before {
    content: "";
    position: absolute;
    top: -2px;
    left: -2px;
    right: -2px;
    bottom: -2px;
    background: linear-gradient(to bottom, #D1E9FF, #FFFFFF);
    z-index: -1;
    border-radius: 8px;
    /* 如果需要圆角 */
  }

  .voiced_warp_bg {
    width: 100%;
    height: 248px;
    position: absolute;
    bottom: 7px;
    right: 0;
  }

  .voiced_warp_title {
    font-weight: 600;
    font-size: 22px;
    color: #27264E;
  }

  .voiced_warp_desc {
    width: 216px;
    font-weight: 400;
    font-size: 16px;
    color: #27264E;
    margin-top: 32px;
    line-height: 34px;
  }

  .voiced_warp_btn {
    width: 254px;
    height: 40px;
    background: #1890FF;
    border-radius: 20px 20px 20px 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: auto;
    margin-top: 83px;
    font-weight: 500;
    font-size: 16px;
    color: #FFFFFF;
    cursor: pointer;
    position: relative;
    z-index: 9;

    .el-icon-microphone {
      font-size: 20px;
      margin-right: 6px;
      margin-top: 2px;
    }
  }
}

.voiced_ing_warp {
  width: 340px;
  height: 368px;
  background: linear-gradient(180deg, #DFEFFE 0%, #D6EAFD 20%, #FFFFFF 100%);
  box-shadow: inset 0px -4px 20px 0px rgba(255, 255, 255, 0.8);
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 48px 0;
  border-radius: 8px;

  &::before {
    content: "";
    position: absolute;
    top: -2px;
    left: -2px;
    right: -2px;
    bottom: -2px;
    background: linear-gradient(to bottom, #D1E9FF, #FFFFFF);
    z-index: -1;
    border-radius: 8px;
    /* 如果需要圆角 */
  }

  .voiced_ing_warp_title {
    font-weight: 500;
    font-size: 22px;
    color: #27264E;
  }

  .voiced_ing_warp_time {
    font-weight: 400;
    font-size: 16px;
    color: #585F65;
    margin-top: 20px;
  }

  .voiced_ing_warp_img {
    width: 100%;
    height: 120px;
  }

  .voiced_ing_warp_text {
    width: 270px;
    overflow: hidden;
    white-space: nowrap;
    height: 20px;

    .scroll_text {
      display: inline-block;
      padding-left: 100%;
      font-weight: 400;
      font-size: 16px;
      color: #27264E;
      animation: scroll 10s linear infinite;
    }
  }

  .voiced_ing_warp_btn {
    width: 120px;
    height: 40px;
    background: #EB5656;
    border-radius: 22px 22px 22px 22px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 500;
    font-size: 16px;
    color: #FFFFFF;
    margin-top: 40px;

    .el-icon-switch-button {
      margin-right: 6px;
    }
  }
}

.voiced_ing_warp2 {
  width: 300px;
  height: 72px;
  background: linear-gradient(93deg, #FFFFFF 0%, #F3F9FF 100%);
  box-shadow: 0px 4px 8px 0px rgba(18, 108, 220, 0.15);
  border-radius: 6px 6px 6px 6px;
  padding: 0 16px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .voiced_ing_warp2_left {
    display: flex;
    align-items: center;
    flex-grow: 0;
    flex-shrink: 0;

    .voiced_ing_warp_img {
      width: 62px;
      height: 62px;
      flex-grow: 0;
      flex-shrink: 0;
    }

    .voiced_ing_warp_center {
      margin-left: 12px;

      .voiced_ing_warp_title {
        font-weight: bold;
        font-size: 16px;
        color: #000000;
      }

      .voiced_ing_warp_time {
        font-weight: 400;
        font-size: 16px;
        color: #585F65;
        margin-top: 4px;
      }
    }
  }

  .voiced_ing_warp_btn {
    width: 66px;
    height: 40px;
    background: #FFFFFF;
    border-radius: 6px 6px 6px 6px;
    border: 1px solid #EFEFEF;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 500;
    font-size: 14px;
    color: #EB5656;
    cursor: pointer;

    .el-icon-switch-button {
      margin-right: 4px;
    }
  }
}
</style>